/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ThemeBasedAsset } from "@anvilor/ngx-theming";
import { NgxThemingConfiguration } from "@anvilor/ngx-theming";
import { LIGHT } from "@anvilor/ngx-theming";
import { DARK } from "@anvilor/ngx-theming";

export const ASSET_ANVILOR_SOLID_ICON: ThemeBasedAsset = {
  light: "https://anvilorsolutions-static.azureedge.net/asl-brand/main/icon-tg.png",
  dark: "https://anvilorsolutions-static.azureedge.net/asl-brand/main/icon-td.png",
};
export const NGX_THEMING_CONFIG: NgxThemingConfiguration = {
  themes: [
    { key: LIGHT, uses_vars: true, contrast: DARK },
    { key: DARK, uses_vars: true, contrast: LIGHT },
  ],
  options: {
    defaultTheme: LIGHT,
    defaultColors: {
      primary: "#9d74e0",
      accent: "#7c4dff",
      warn: "#f44336",
    },
  },
};
